// Shared constants and utilities for the MPR tab.
// Single source of truth — never duplicate these in the parent Stores.jsx.

export const MPR_PLAN_FREQUENCIES = ['Daily', 'Weekly', 'Monthly', 'Quarterly', 'Half-Yearly', 'Yearly', 'One-time'];
export const MPR_SOURCE_BASES = ['Reorder Level', 'Production Forecast', 'DPR'];

export const mprStatusClass = (s) => {
  const k = (s || '').toLowerCase();
  if (k.includes('approved') && !k.includes('pending')) return 'bg-emerald-100 text-emerald-700';
  if (k.includes('pending')) return 'bg-amber-100 text-amber-700';
  if (k.includes('reject')) return 'bg-rose-100 text-rose-700';
  if (k.includes('rfq') || k.includes('awarded') || k.includes('closed')) return 'bg-teal-100 text-teal-700';
  return 'bg-gray-100 text-gray-600';
};

export const blankLine = () => ({ _key: Math.random(), material_id: '', material_name: '', uom: '', qty: '', notes: '' });
